var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-overlay",
    { attrs: { "instance-class": "product-consent-management", id: _vm.id } },
    [
      _c("div", { staticClass: "modal-overlay__content__item" }, [
        _c("h1", { staticClass: "heading1 custom-color-f" }, [
          _vm._v("\n            Wir benötigen Ihre Zustimmung\n        "),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            Wenn Sie uns Ihre Zustimmung geben, messen wir die Anzahl der Seitenaufrufe. Dies ermöglicht es uns zu erkennen, wie viele Personen unsere Webseite aufrufen. Für diese Analyse nutzen wir Google Analytics 4 mit der Standardmessung, alles andere ist deaktiviert. Die Nutzung der Daten zu eigenen Zwecken haben wir Google untersagt. Ihre IP-Adresse wird umgehend gelöscht.\n        "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            Mit Ihrer Zustimmung laden wir auch ein LiveChat-Widget, worüber Sie mit den Experten von „Frag die Apotheke“ chatten können. Dabei werden technische Daten wie insb. die IP-Adresse weitergegeben und Cookies verwendet. Für Ihre Nutzung des Chats gelten die "
          ),
          _c(
            "a",
            {
              staticClass: "custom-color-b",
              attrs: {
                href: "https://frag-die-apotheke.de/datenschutz",
                target: "_blank",
                rel: "noopener noreferrer nofollow",
              },
            },
            [_vm._v(" Datenschutzhinweise von „Frag die Apotheke“")]
          ),
          _vm._v(".\n        "),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            Mit dem Klick auf „Zustimmen“ stimmen Sie der Verarbeitung der auf Ihrem Gerät bzw. Ihrer Endeinrichtung gespeicherten Daten wie z.B. persönlichen Identifikatoren oder IP-Adressen für die Verarbeitungszwecke gem. § 25 Abs. 1 TDDDG sowie Art. 6 Abs. 1 lit. a DSGVO zu.\n        "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            Sie können Ihre Einwilligungserklärung auch detailliert anpassen. In unserer "
          ),
          _c(
            "a",
            {
              staticClass: "custom-color-b",
              attrs: {
                href: "/Datenschutz",
                target: "_blank",
                rel: "noopener noreferrer nofollow",
              },
            },
            [_vm._v("Datenschutzerklärung")]
          ),
          _vm._v(
            " finden Sie weitere Informationen zu diesen Datenverarbeitungen sowie zum Widerruf Ihrer Einwilligung(en).\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "consent-line" }, [
          _vm._v("\n            Websiteanalyse\n            "),
          _c("label", { staticClass: "toggle-switch" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.gaConsent,
                  expression: "gaConsent",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.gaConsent)
                  ? _vm._i(_vm.gaConsent, null) > -1
                  : _vm.gaConsent,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.gaConsent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.gaConsent = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.gaConsent = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.gaConsent = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "slider" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "consent-line" }, [
          _vm._v(
            "\n            Externe Inhalte („Frag die Apotheke“)\n            "
          ),
          _c("label", { staticClass: "toggle-switch" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.fdaConsent,
                  expression: "fdaConsent",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.fdaConsent)
                  ? _vm._i(_vm.fdaConsent, null) > -1
                  : _vm.fdaConsent,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.fdaConsent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.fdaConsent = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.fdaConsent = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.fdaConsent = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "slider" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button-container" }, [
          _c(
            "button",
            {
              staticClass:
                "button button--invert custom-color-b custom-border-color-b",
              on: { click: _vm.dissent },
            },
            [_vm._v("\n                Ablehnen\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "button button--invert custom-color-b custom-border-color-b",
              on: { click: _vm.save },
            },
            [_vm._v("\n                Auswahl speichern\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "button button--invert custom-color-b custom-border-color-b",
              on: { click: _vm.consent },
            },
            [_vm._v("\n                Zustimmen\n            ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }